import React from 'react';
import { Switch, Route, useHistory, useRouteMatch } from 'react-router-dom';
import { Layout, Menu, Typography, Button } from 'antd';
import { useAuth } from '../../contexts/auth';
import './style.css';
import logo from '../../assets/logo.png';

import Users from './users';
import News from './news';
import Indicators from './indicators';
import LegalReports from './legalReports';
import Calculator from './calculator';

import { BarChartOutlined,
  ReconciliationOutlined,
  ExceptionOutlined,
  CalculatorOutlined,
  TeamOutlined,
} from '@ant-design/icons';
const { Header, Footer, Sider } = Layout;
const { Title } = Typography;



function Home() {
  const { logout, user } = useAuth();
  const history = useHistory();
  let { path, url } = useRouteMatch();

  const routes = [
    {
      key: 1,
      title: 'Usuários',
      icon: () => <TeamOutlined />,
      to: `${url}`,
      path: `${path}`,
      screen: () => <Users />,
    },
    {
      key: 2,
      title: 'Notícias',
      icon: () => <ExceptionOutlined />,
      to: `${url}news`,
      path: `${path}news`,
      screen: () => <News />,
    },
    {
      key: 3,
      title: 'Indicadores',
      icon: () => <BarChartOutlined />,
      to: `${url}indicators`,
      path: `${path}indicators`,
      screen: () => <Indicators />,
    },
    {
      key: 4,
      title: 'Relatórios Legais',
      icon: () => <ReconciliationOutlined />,
      to: `${url}legal-reports`,
      path: `${path}legal-reports`,
      screen: () => <LegalReports />,
    },
    {
      key: 5,
      title: 'Calculadora',
      icon: () => <CalculatorOutlined />,
      to: `${url}calculator`,
      path: `${path}calculator`,
      screen: () => <Calculator />,
    }
  ];

  function handleLogout() {
    logout();
    history.push('/');
  }
  return (
    <Layout
      style={{ height: '100vh' }}
    >
      <Sider
        className="sider-left"
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={broken => {
          console.log(broken);
        }}
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
      >
        <img alt="Logo" className="logo" src={logo}
        />
        <Menu className="menu-left" theme="dark" mode="inline" defaultSelectedKeys={['1']}>
          {routes.map((route) => (
            <Menu.Item key={route.key} icon={route.icon()} onClick={() => history.push(route.to)}>
              {route.title}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout>
        <Header className="site-layout-sub-header-background">
          {!!user && user?.username && (
            <Title level={3}>@{user.username}</Title>
          )}
          <Button
            className="logout-button"
            type="primary"
            onClick={handleLogout}
          >
            Sair
          </Button>
        </Header>
        <Switch>
          {routes.map((route, index) => {
            return (
              <Route key={route.key} exact={index === 0} path={route.path}>
                {route.screen()}
              </Route>
            );
          })}
        </Switch>
        <Footer style={{ textAlign: 'center' }}>Cooperativa Cocrafi ©2021 Criado por Torchlight Innovation and Technology</Footer>
      </Layout>
    </Layout>
  );
}

export default Home;